export const eventData = {
    1: {
        status: 'end',
        title: "QR/NFC 오더 오픈이벤트",
    }, 
    2: {
        status: 'hide',
        title: "몽땅 다드림 이벤트",
    },
    3: {
        status: 'end',
        title: "네이버 블로그 리뷰 이벤트",
    },
    4: {
        status: 'end',
        title: "인스타그램 리뷰 이벤트",
    }, 
    5: {
        status: 'end',
        title: "5월의 꽃피는 웨이팅",
    }, 
    6: {
        status: 'end',
        title: "스마트스토어 포토리뷰 이벤트",
    }, 
    7: {
        status: 'end',
        title: "얼리버드 추석 이벤트",
    }, 
    8: {
        status: 'end',
        title: "가을맞이 헬로어텀 이벤트",
    }, 
    9: {
        status: 'end',
        title: "포인트적립 첫 달 무료!",
    }, 
    10: {
        status: 'end',
        title: "QR오더 첫 달 무료!",
    }, 
    11: {
        status: 'end',
        title: "최저가 보장 이벤트",
    }, 
    12: {
        status: 'end',
        title: "다드림 패키지 이벤트",
    },
    13: {
        status: 'end',
        title: "단독서버 할인패키지 출시",
    },
    14: {
        status: 'end',
        title: "가정의달 혜택왔어요",
    },
    15: {
        status: 'end',
        title: "QR웨이팅 신규도입 이벤트",
    },
    16: {
        status: 'end',
        title: "QR오더 11월 이벤트",
    },
    17: {
        status: 'end',
        title: "BLACK FRIDAY",
    },
    19: {
        status: 'end',
        title: "월간 지역할인",
    },
    20: {
        status: 'end',
        title: "2월 지역할인(여의도)",
    },
    21: {
        status: 'end',
        title: "만나서 반값습니다!",
    },
    22: {
        status: 'end',
        title: "반가운 혜택!",
    },
};